var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSquarePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16.163 16",
    width: 16.163,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c2f87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.693 2.714a.552.552 0 0 1 0 .779l-1.151 1.152-2.207-2.207 1.151-1.152a.552.552 0 0 1 .78 0l1.427 1.427zm-1.931 2.71-2.207-2.207-7.518 7.519a.552.552 0 0 0 -.133.216l-.888 2.664a.276.276 0 0 0 .349.349l2.664-.888a.552.552 0 0 0 .216-.132l7.518-7.519z",
    transform: "translate(-5.691 -1.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.25 16.043a1.655 1.655 0 0 0 1.655 1.657h12.138a1.655 1.655 0 0 0 1.657-1.657v-6.621a.552.552 0 0 0 -1.1 0v6.621a.552.552 0 0 1 -.552.552h-12.143a.552.552 0 0 1 -.552-.552v-12.138a.552.552 0 0 1 .552-.552h7.172a.552.552 0 1 0 0-1.1h-7.172a1.655 1.655 0 0 0 -1.655 1.652z",
    fillRule: "evenodd",
    transform: "translate(-2.25 -1.698)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSquarePrimary);
export default __webpack_public_path__ + "static/media/pencil-square-primary.7edc9f1b933af1e1f0555741e03c3166.svg";
export { ForwardRef as ReactComponent };